import { AddIcon } from '@chakra-ui/icons';
import { HStack } from '@chakra-ui/react';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import useGetSpecialNumbers from './queries/useGetSpecialNumbers';

import { Button, Text } from '@/components/v4';
import AGGridMain from 'components/tables/AGGrid/AGGridMain';
import useColumnState from '../../../hooks/useColumnState';

import { getSpecialNumbersTableColumns } from './specialNumbersTableConfig';

export default function SpecialNumbers() {
    const gridRef = useRef();
    const navigate = useNavigate();

    const { darkMode } = useSelector((state) => state.settings);

    const [tableData, setTableData] = useState({
        columns: [],
        data: [],
    });

    const handleEditSpecialNumber = useCallback(
        (specialNumberData) => {
            navigate(`/special-numbers/edit/${specialNumberData.id}`);
        },
        [navigate],
    );

    const handleAddSpecialNumber = () => {
        navigate('/special-numbers/add');
    };

    const baseColumns = useMemo(
        () =>
            getSpecialNumbersTableColumns({
                darkMode,
                onEditSpecialNumber: handleEditSpecialNumber,
            }),
        [darkMode, handleEditSpecialNumber],
    );

    const { columns, onColumnVisible } = useColumnState(baseColumns);

    const tableDataWithColumns = useMemo(
        () => ({
            columns,
            data: tableData.data,
        }),
        [columns, tableData.data],
    );

    const { refetch, isRefetching, isFetching } = useGetSpecialNumbers(
        setTableData,
        gridRef,
        baseColumns,
    );

    const isFetchingData = isRefetching || isFetching;

    const titleName = 'Special Numbers';

    return (
        <>
            <HStack justifyContent="space-between" marginBottom={5}>
                <Text sx={{ fontSize: '20', fontWeight: '500' }}>
                    Special Numbers
                </Text>
            </HStack>

            <AGGridMain
                gridRef={gridRef}
                tableData={tableDataWithColumns}
                isLoading={isFetchingData}
                titleName={titleName}
                refetch={refetch}
                onColumnVisible={onColumnVisible}
                extraComponents={
                    <HStack pl={5} spacing={2}>
                        <Button
                            leftIcon={<AddIcon />}
                            onClick={handleAddSpecialNumber}
                            size="sm"
                            padding="6px 12px">
                            Add Special Number
                        </Button>
                    </HStack>
                }
            />
        </>
    );
}
